import { RawSiteSettingState, SiteSettingState } from './types';
import { transformMenusWithChildren } from './helper';
import _ from 'lodash';
import { addSnackbar } from '../snackbar/snackbarSlice';
import { QueryErrorReturnValue } from '../../types';
import { API_URLS } from '../../../routes/urls';
import { apiSlice } from '../../apiSlice';
import { EducationLevel } from '../../../types/siteSetting';

export const initialSiteSettingState: SiteSettingState = {
  menus: {
    Footer: [],
    Header: [],
  },
  siteSetting: {
    site_info: {},
    social_links: {},
  },
};

/**
 * State management for app site setting
 * Includes menus and site setting configuration from admin
 */
const siteSettingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchSiteSettings: builder.query<SiteSettingState, void>({
      async queryFn(_arg, _queryApi, _extraOptions, api) {
        const siteSettingResult = await Promise.all([
          api({
            url: API_URLS.siteSettings,
          }),
          api({
            url: API_URLS.menus,
          }),
        ]);

        /**
         * Error handling for site setting api and menu api
         * and transforming menus
         */
        const siteSettingApiResponse = siteSettingResult[0];
        if (siteSettingApiResponse.error) return { error: siteSettingApiResponse.error };

        const menuApiResponse = siteSettingResult[1];
        if (menuApiResponse.error) return { error: menuApiResponse.error };

        const rawMenus = menuApiResponse.data as RawSiteSettingState['menus'];
        const menus: SiteSettingState['menus'] = {
          Header: transformMenusWithChildren(_.concat(rawMenus['Main Navigation'] || [], rawMenus.Header || [])),
          Footer: transformMenusWithChildren(rawMenus.Footer || []),
        };

        return {
          data: {
            siteSetting: siteSettingApiResponse.data,
            menus,
          } as SiteSettingState,
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          const err = error as QueryErrorReturnValue;
          dispatch(
            addSnackbar({
              message: err.error.message,
              severity: 'error',
            })
          );
        }
      },
    }),

    educationLevels: builder.query<EducationLevel[], void>({
      query: () => ({
        url: API_URLS.educationLevels,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useFetchSiteSettingsQuery, useEducationLevelsQuery } = siteSettingApi;
